// 此文件由 json_to_games.py 自动生成
// 生成时间: 2025-03-25 22:41:11

export default {
  "id": "superhero-phone-simulator",
  "slug": "superhero-phone-simulator",
  "publisher": "GoGameVault",
  "thumbnail": "https://img.gamedistribution.com/7044c2d00a2f46e49c205da679cb6421-512x384.jpg",
  "gameUrl": "https://html5.gamedistribution.com/7044c2d00a2f46e49c205da679cb6421/",
  "releaseDate": "2025-03-25",
  "rating": 4.5,
  "plays": 0,
  "isNew": true,
  "isPopular": false,
  "isRecommended": false,
  "i18n": {
    "en": {
      "title": "Superhero Phone Simulator",
      "description": "Explore action-packed mini-games, customize your hero, and test your skills in fun challenges. Whether you enjoy racing, creativity, or exciting adventures, this app has everything you need for endless fun!",
      "instructions": "Bottle Smash: tap or click to shoot\nSkateboarding Rush: buttons on screen for jump and sit\nCar Racing: swipe left or right to move\nWeb Swinging: tap to shoot web, button on screen to let go of the web\nFishing Frenzy: Buttons on screen for throw hook and pull the reel\nWall Climber: swipe left or right to move\nCreative Studio: draw with the tools on the screen",
      "genres": [
        "Casual"
      ],
      "tags": [
        "kidgames",
        "phone",
        "spiderman",
        "superhero"
      ]
    },
    "zh-CN": {
      "title": "超级英雄手机模拟器",
      "description": "探索充满动作的迷你游戏，定制你的英雄，并在有趣挑战中测试你的技能。无论是喜欢竞速、创意还是激动人心的冒险，这个应用拥有你需要的一切，带来无尽的乐趣！",
      "instructions": "瓶砸：点击或轻触射击\n滑板冲浪：屏幕上的按钮用于跳跃和坐下\n赛车：向左或向右滑动移动\n蜘蛛网摇摆：轻触发射蜘蛛网，屏幕上的按钮用于释放蜘蛛网\n垂钓狂潮：屏幕上的按钮用于抛掷鱼钩和拉回卷轴\n攀墙者：向左或向右滑动移动\n创意工作室：使用屏幕上的工具绘图",
      "genres": [
        "休闲"
      ],
      "tags": [
        "儿童游戏",
        "手机",
        "蜘蛛侠",
        "超级英雄"
      ]
    },
    "zh-TW": {
      "title": "超級英雄手機模擬器",
      "description": "探索充滿動作的小遊戲，自訂你的英雄，並在有趣的挑戰中測試你的技巧。無論你喜歡賽車、創造力或刺激冒險，這個應用程式都有你無窮樂趣所需的一切！",
      "instructions": "瓶破：點擊或滑動射擊\n滑板衝刺：螢幕上按鈕跳躍和坐下\n賽車：向左或向右滑動移動\n網絡揮舞：點擊射擊蛛絲，螢幕上按鈕釋放蛛絲\n釣魚瘋狂：螢幕上按鈕拋釣和拉動繩輪\n牆壁攀登：向左或向右滑動移動\n創意工作室：使用螢幕上的工具繪製",
      "genres": [
        "隨意"
      ],
      "tags": [
        "兒童遊戲",
        "手機",
        "蜘蛛人",
        "超級英雄"
      ]
    },
    "zh-HK": {
      "title": "超級英雄手機模擬器",
      "description": "探索充滿動作的小遊戲，自訂您的英雄，並在有趣的挑戰中測試您的技能。無論您喜歡賽車、創意還是刺激的冒險，這個應用程式都有您需要的不斷歡樂！",
      "instructions": "瓶壺粉碎：輕觸或點擊發射\n滑板急速：螢幕上按鈕跳躍和蹲下\n賽車：向左或向右滑動移動\n網索飛翔：輕觸發射網索，螢幕上按鈕放開網索\n釣魚瘋狂：螢幕上按鈕拋釣魚勾和拉動繩盤\n牆壁攀登：向左或向右滑動移動\n創意工作室：使用螢幕上工具繪製",
      "genres": [
        "隨意"
      ],
      "tags": [
        "兒童遊戲",
        "手機",
        "蜘蛛俠",
        "超級英雄"
      ]
    },
    "ja": {
      "title": "スーパーヒーロー携帯電話シミュレーター",
      "description": "アクション満載のミニゲームを探索し、ヒーローをカスタマイズして、楽しい挑戦であなたのスキルを試してみてください。レース、クリエイティビティ、または興奮するアドベンチャーが好きな人でも、このアプリは無限の楽しみのためのすべてを提供しています！",
      "instructions": "ボトルスマッシュ：タップまたはクリックで射撃\nスケートボードラッシュ：スクリーンのボタンでジャンプと座る\nカーレーシング：左または右にスワイプして移動\nウェブスウィング：タップしてウェブを射出、スクリーンのボタンでウェブを放す\nフィッシングフレンジ：スクリーンのボタンでルアーを投げると巻き上げる\nウォールクライマー：左または右にスワイプして移動\nクリエイティブスタジオ：スクリーンのツールで描く",
      "genres": [
        "カジュアル"
      ],
      "tags": [
        "キッドゲームズ",
        "スマートフォン",
        "スパイダーマン",
        "スーパーヒーロー"
      ]
    },
    "ko": {
      "title": "스ーパーヒ어로 휴대폰 시뮬레이터",
      "description": "액션 가득한 미니 게임을 탐험하고, 영웅을 커스터마이즈하고, 재미있는 도전에서 실력을 테스트하세요. 레이싱, 창의성, 또는 흥미진진한 모험을 좋아하는 분들도 이 앱에서 무한한 즐거움을 얻을 수 있습니다!",
      "instructions": "병打破: 탭하거나 클릭하여 발사\n스케이트보딩 런: 화면의 버튼을 눌러서 점프하고 앉아서\n카 레이싱: 왼쪽 또는 오른쪽으로 스와이프하여 이동\n웹 스윙: 웹을 발사하려면 탭하십시오, 화면의 버튼을 눌러서 웹을 놓치십시오\nangling Frenzy: 화면의 버튼을 눌러서 대용도를 던지고 루프를 당겨서\n벽 등반자: 왼쪽 또는 오른쪽으로 스와이프하여 이동\n창의 스튜디오: 화면의 도구로 그림을 그리십시오",
      "genres": [
        "캐주얼"
      ],
      "tags": [
        "키드게임즈",
        "폰",
        "스파이더맨",
        "슈퍼히어로"
      ]
    },
    "fr": {
      "title": "Simulateur de Téléphone Superhéros",
      "description": "Explorez des mini-jeux d'action, personnalisez votre héros et testez vos compétences dans des défis amusants. Que vous aimiez les courses, la créativité ou des aventures captivantes, cette application a tout ce qu'il vous faut pour un divertissement infini !",
      "instructions": "Bottle Smash : appuyez ou cliquez pour tirer\nSkateboarding Rush : boutons sur l'écran pour sauter et s'asseoir\nCar Racing : glissez à gauche ou à droite pour vous déplacer\nWeb Swinging : appuyez pour tirer le filet, bouton sur l'écran pour lâcher le filet\nFishing Frenzy : boutons sur l'écran pour jeter l'hameçon et tirez le frein\nWall Climber : glissez à gauche ou à droite pour vous déplacer\nCreative Studio : dessinez avec les outils sur l'écran",
      "genres": [
        "Casual"
      ],
      "tags": [
        "jeux_enfants",
        "téléphone",
        "spiderman",
        "superhéros"
      ]
    }
  }
};
